import { ITranslationKey } from '../../ITranslationKey';
import { ITranslationSchema } from '../TranslationSchema';
import {
  BaseTranslationSchema,
  ITranslationUpdateContext,
  TranslationSchemaType,
} from './BaseTranslationSchema';

export class TranslationArraySchema extends BaseTranslationSchema {
  type = TranslationSchemaType.Array;

  constructor(private itemSchema: ITranslationSchema) {
    super();
  }

  extract(value: any, path: string, prefix: string): ITranslationKey[] {
    if (!value || !Array.isArray(value)) return [];

    return value.flatMap((item, index) => {
      return this.itemSchema.extract(
        item,
        `${path}[${index}]`,
        `${prefix}`, // Non aggiungiamo l'indice in modo da poter gestire i riordinamenti
      );
    });
  }

  translateValue(
    value: any,
    path: string,
    prefix: string,
    ctx: ITranslationUpdateContext,
  ): void {
    if (!value || !Array.isArray(value)) return;

    value.forEach((item, index) => {
      this.itemSchema.translateValue(
        item,
        `${path}[${index}]`,
        `${prefix}`, // Non aggiungiamo l'indice in modo da poter gestire i riordinamenti
        ctx,
      );
    });
  }
}
